import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/app.state';
import * as UserActions from '../../../store/user/actions';
import { JWTTokenService } from '../jwt-token-service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  public jwtToken: string;

  constructor(
    public router: Router,
    public http: HttpClient,
    private store: Store<AppState>,
    private jwtTokenService: JWTTokenService,
  ) {}

  canActivate(): Observable<boolean> {
    this.jwtToken = this.jwtTokenService.getJwtCookie(environment.sessionTokenName);

    const renewUrl = `${environment.ssoUrl}${environment.ssoSilentAuthUrl}`;
    return this.http.post<any>(renewUrl, {refresh_token: this.jwtToken}).pipe(map((response) => {
      if (response['success']) {
        this.store.dispatch(new UserActions.SetAccessTokenLoaded());
        this.jwtTokenService.setToken(response.data['access_token']);
        return true;
      }
      this.redirectToLogin();
    }));
  }

  redirectToLogin(): boolean {
    window.location.replace(
      `${environment.ssoUrl + environment.ssoAuthUrl}?state=${encodeURIComponent(window.location.href)}`
    );
    return false;
  }

}
